export default __webpack_public_path__ + "static/media/site_ciosenegal.81a1f0f6.webp";